module.exports = __webpack_public_path__ + "img/pasture_brachiaria_low.01302bb9.jpg";